<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:left_view>
      <OrganizationalTree ref="organizationalTree" :nodeSelectProp='getInfo' :neid="neidByQryTree"></OrganizationalTree>
    </template>
    <template v-slot:right_view>
      <ToolBar
        :addBtn="true"
        :delBtn="true"
        :editBtn="true"
        :refreshBtn="true"
        :keywordsInputStaff="true"
        @notice="notice"
        @props="props"
      ></ToolBar>
      <div class="h100vh-180">
      <ejs-grid :allowPaging="true" :allowResizing='true' ref="grid" :pageSettings="pageSettings"　height="calc(100% - 0px)">
          <e-columns>
            <e-column type='checkbox'  width='40' textAlign='Center'></e-column>
            <e-column field='staffnum' :headerText="$t('SubscriberIms.staffId')" width='110' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='staffname' :headerText="$t('SubscriberIms.staffName')" width='110' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='platenum' :headerText="$t('SubscriberIms.licenseNum')" width='180' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='udn' :headerText="$t('SubscriberIms.subNum')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='post' :headerText="$t('SubscriberIms.profession')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='worktype' :headerText="$t('SubscriberIms.post')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='unitname' :headerText="$t('SubscriberIms.unitName')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='unitcode' :headerText="$t('SubscriberIms.unitCode')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='telnum' :headerText="$t('SubscriberIms.mobile')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='usetype' :headerText="$t('SubscriberIms.use')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='terminaltype' :formatter='rtttypeFormat' :headerText="$t('SubscriberIms.terType')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize='pageSettings.pageSize' :currentPage='pageSettings.pageNo' :totalRecordsCount='pageSettings.totalCount'
          @click="getInfoP"
        ></ejs-pager>
      </div>
      <CustomDialog
        ref="addDialog"
        v-bind:element="addDialog.element"
        v-bind:styles="addDialog.styles"
      >
        <template v-slot:dialog-content>
          <ImsInfoDialog ref="infoDialog" v-bind:opCode="opCode" v-bind:msgid="msgid" v-bind:neid="neid"></ImsInfoDialog>
        </template>
      </CustomDialog>
      <CustomDialog ref='dialogListPage' :element='eleDialogList' :styles='styles'>
        <template v-slot:dialog-content>
          <DialogList ref='dialogList'></DialogList>
        </template>
      </CustomDialog>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../../layouts/BasicLayout';
import CustomDialog from '../../../../components/common/CustomDialog';
import OrganizationalTree from '../../../../components/subscriberconfig/util/OrganizationalTree';
import ToolBar from '../../../../components/subscriberconfig/imsSubscriber/ToolBar';
import ImsInfoDialog from '../../../../components/subscriberconfig/imsSubscriber/staff/ImsInfoDialog';
import DialogList from '../../../../components/subscriberconfig/util/tipDialog/DialogList';
import { Resize } from '@syncfusion/ej2-vue-grids';
import { EventBus } from '../../../../plugins/eventBus';

export default {
  name: "ImsInfoManagement",
  provide: {
    grid: [Resize]
  },
  data() {
    return {
      neidByQryTree: null,
      left: {
        show: true,
        name: this.$t('SubscriberIms.organization')
      },
      middle: {
        show: false,
        name: ""
      },
      right: {
        show: true,
        crumb: this.$t('SubscriberIms.infoTitle')
      },
      addDialog: {
        element: {
          target: "#app",
          isClose: true,
          refName: "addInfo",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t("System.cancel")}` }
            },
            {
              click: this.confirmAdd,
              buttonModel: { content: `${this.$t("System.confirm")}` ,isPrimary: true}
            }
          ],
          title: this.$t('SubscriberIms.add')
        },
        styles: {
          width: "810px",
          height: "auto",
          model: true,
          visible: false
        }
      },
      organization: {},
      pageSettings: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      pageCount: 4,
      toolBarProps:{},
      opCode:'',
      msgid: 0,
      neid: 0,
      addMsgid: 27838,
      modMsgid: 27839,
      delMsgid: 27840,
      shwMsgid: 27841,
      vpnid: 0,
      eleDialogList: {
        target: '#app',
        refName: 'dialogList',
        buttonGroup: [
          {
            click: this.closeDialogListTipPage,
            buttonModel: { content: this.$t('SubscriberIms.confirm') }
          }
        ],
        title: this.$t('SubscriberIms.logTitle'),
        isClose: true,
      },
      styles: {
        width: '810px',
        height: '760px',
        visible: false,
        model: true
      },
    gridTypeEnum: {
      rtttype: [,,this.$t('SubscriberIms.rtttype2'),,this.$t('SubscriberIms.rtttype4'),this.$t('SubscriberIms.rtttype5'),this.$t('SubscriberIms.rtttype6'),,this.$t('SubscriberIms.rtttype8')]
    }
    };
  },
  methods: {
    closeDialogListTipPage() {
      this.$refs.dialogListPage.clear();
      this.$refs.dialogListPage.close()
    },
    notice(btn) {
      if (JSON.stringify(this.organization)=="{}") {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.checkVpnTip')});
        return null;
      }
      if (btn === 'add') {
        this.addFunc();
      }
      if (btn === 'del') {
        this.delFunc();
      }
      if (btn === 'edit') {
        this.editFunc();
      }
      if (btn === 'refresh') {
        this.refreshFunc();
      }
    },
    addFunc() {
      this.opCode = 'add';
      this.msgid = this.addMsgid;
      this.addDialog.element.title = this.$t('SubscriberIms.add');
      this.$nextTick(() => {
        this.$refs.infoDialog.mainHandler();
        this.$refs.addDialog.show();
      });
    },
    delFunc() {
      const record = this.getRecord();
      if (record == null) {
        return null;
      }
      const url = '/lte/ems/subscriber/imsunms/requestCommon';
      this.msgid = this.delMsgid;
      const logParam = {
        module: 'res.subscriber#res.subscriber_ims#res.subscriber_ims_info',
        execFunName: 'subscriber.delStaff',
        exectype: 3,
        execData: []
      };
      const params = {
        vo: {
          0: {
            vo: record,
            info: { msgid: this.delMsgid, neid: this.neid }
          }
        },
        info: {
          operation: 'bacthOperate'
        },
        log: logParam
      };
      const _showDatas = [];
      record.forEach((item) => {
        const showData = {};
        showData.operObj = item.staffid;
        _showDatas.push(showData);
      });
      this.axios.post(url, params).then(response => {
        const result = response['data']['resultVal'];
        this.$refs.dialogListPage.show();
        result.forEach((item, index) => {
          _showDatas[index].operResult = item.display;
          _showDatas[index].operCode = item.code;
        });
        this.$refs.dialogList.addOperetionResultList(_showDatas);
        this.getInfo(this.organization,true);
      });
    },
    editFunc() {
      const record = this.getRecord();
      if (record === null) {
        return null;
      }
      if (record.length != 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.checkDataMoreTip')});
        return null;
      }
      this.opCode = 'mod';
      this.msgid = this.modMsgid;
      this.addDialog.element.title = this.$t('SubscriberIms.mod');
      this.$nextTick(() => {
        this.$refs.infoDialog.mainHandler(record[0]);
        this.$refs.addDialog.show();
      });
    },
    refreshFunc() {
      this.getInfo(this.organization);
    },
    props(data) {
      this.toolBarProps = data;
      this.getInfo(this.organization);
    },
    dialogHide() {
      this.$refs.addDialog.clear();
      this.$refs.addDialog.close();
    },
    confirmAdd(){
      const url = '/lte/ems/subscriber/imsunms/requestCommon';
      const vo = this.$refs.infoDialog.getDatas();
      if (vo == null) {
        return null;
      }
      this.$refs.addDialog.clear();
      this.$refs.addDialog.close();
      if(this.opCode == 'add'){
        vo['vpnid'] = this.vpnid;
      }
      vo['neid'] = this.neid;
      const logParam = {
        module: 'res.subscriber#res.subscriber_ims#res.subscriber_ims_info',
        execFunName: this.msgid == this.addMsgid ? 'subscriber.addStaff':'subscriber.modStaff',
        exectype: this.msgid == this.addMsgid ? 1 : 2,
        execData: []
      };
      const params = {
        vo: vo,
        info: {
          neid: this.neid,
          msgid: this.msgid
        },
        log: logParam
      }
      this.axios.post(url, params).then(response => {
        EventBus.$emit('toast', {type: 'success', content: response['data']['resultVal'][0].display });

       // this.$layer.warn({ msg: response['data']['resultVal'][0].display });
        this.getInfo(this.organization);
      });
    },
    getRecord(){
      const record = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (record == null || record == '') {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.selectOneMessage')});
        return null;
      }
      return record;
    },
    getInfo(obj, delFlag = false){
      this.organization = obj;
      this.neid = parseInt(obj.id.split('_')[0]);
      this.vpnid = parseInt(obj.id.split('_')[2]); //TODO
      this.vpnclass = parseInt(this.organization.level, 0) - 1;
      this.msgid = this.shwMsgid;
      const pageNo = this.$refs.pager.ej2Instances.currentPage;
      this.pageSettings.pageNo = this.$refs.pager.ej2Instances.currentPage;
      if (delFlag) {
          this.pageSettings.pageNo = 1;
      }
      const url = '/lte/ems/subscriber/imsunms/requestCommon';
      const params = {
        vo : {"vpnid":this.vpnid,"vpnClass":this.vpnclass,"flag":2,"staffname":this.toolBarProps.keywordStaff},
        info : {
          neid: this.neid,
          msgid: this.msgid
        },
        page: {
          pageNo: pageNo,
          pageSize: this.pageSettings.pageSize
        }
      };
      this.axios.post(url, params).then(response => {
        const result = response.data.resultVal;
        const showRe = result.resultList;
        this.$refs.grid.ej2Instances.dataSource = showRe;
        this.$refs.pager.ej2Instances.totalRecordsCount =
          result.countrsp;
        setTimeout(()=> {
          if (result.countrsp === 0) { // 没有数据---组件会将domtokenlist增加e-checkbox-disabled属性
            debugger;
            const temp = this.$refs.grid.$el.childNodes[2].children[0].children[0].children[1].children[0].children[0].children[0].children[0].classList;
            if (temp.length > 2) {
              temp.remove('e-checkbox-disabled');
            }
          }
        }, 100);
      });
    },
    getInfoP(){
      if (this.organization == '' || this.organization == null) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.checkVpnTip')});
        return null;
      }
      this.getInfo(this.organization);
    },
    rtttypeFormat(grids,data){
      return this.gridTypeEnum.rtttype[data.terminaltype];
    },

  },
  components: {
    BasicLayout,
    CustomDialog,
    OrganizationalTree,
    ToolBar,
    ImsInfoDialog,
    DialogList
  },
  mounted() {
    this.$refs.organizationalTree.getOrganizationalTree();
  }
};
</script>
